import { TAction } from '../../../../../../shared/frontend/scripts/actions/types/action';
import {
  TCreateTimelineEvent,
  TGetTimelineEventListParams,
  TUpdateTimelineEvent
} from '../../../../shared/types/timelineEventTypes';
import {
  TTimelineEventManagementDetailsState,
  TTimelineEventManagementListState,
  TTimelineEventManagementState
} from '../../libs/store';

const getInitialState = (): TTimelineEventManagementState => ({
  list: {
    isLoading: false,
    isLoaded: false,
    data: [],
    ui: {},
    error: null
  },
  details: {
    isLoading: false,
    isLoaded: false,
    data: null,
    ui: {},
    error: null
  },
  requestPending: false
});

const FETCH_TIMELINE_EVENT_MANAGEMENT_LIST = 'TIMELINE_EVENT_MANAGEMENT/FETCH_TIMELINE_EVENT_MANAGEMENT_LIST';
const FETCH_TIMELINE_EVENT_MANAGEMENT_DETAILS = 'TIMELINE_EVENT_MANAGEMENT/FETCH_TIMELINE_EVENT_MANAGEMENT_DETAILS';
const CREATE_TIMELINE_EVENT = 'TIMELINE_EVENT_MANAGEMENT/CREATE_TIMELINE_EVENT';
const UPDATE_TIMELINE_EVENT = 'TIMELINE_EVENT_MANAGEMENT/UPDATE_TIMELINE_EVENT';
const DELETE_TIMELINE_EVENT = 'TIMELINE_EVENT_MANAGEMENT/DELETE_TIMELINE_EVENT';
const SET_REQUEST_PENDING = 'TIMELINE_EVENT_MANAGEMENT/SET_REQUEST_PENDING';

const UPDATE_TIMELINE_EVENT_MANAGEMENT_LIST = 'TIMELINE_EVENT_MANAGEMENT/UPDATE_TIMELINE_EVENT_MANAGEMENT_LIST';
const UPDATE_TIMELINE_EVENT_MANAGEMENT_DETAILS = 'TIMELINE_EVENT_MANAGEMENT/UPDATE_TIMELINE_EVENT_MANAGEMENT_DETAILS';
const RESET_TIMELINE_EVENT_MANAGEMENT_LIST = 'TIMELINE_EVENT_MANAGEMENT/RESET_TIMELINE_EVENT_MANAGEMENT_LIST';
const RESET_TIMELINE_EVENT_MANAGEMENT_DETAILS = 'TIMELINE_EVENT_MANAGEMENT/RESET_TIMELINE_EVENT_MANAGEMENT_DETAILS';

const fetchTimelineEventManagementList = (params: TGetTimelineEventListParams) => ({
  type: FETCH_TIMELINE_EVENT_MANAGEMENT_LIST,
  payload: params
});

const fetchTimelineEventManagementDetails = (id: string) => ({
  type: FETCH_TIMELINE_EVENT_MANAGEMENT_DETAILS,
  payload: id
});

const updateTimelineEventManagementList = (data: Partial<TTimelineEventManagementListState>) => ({
  type: UPDATE_TIMELINE_EVENT_MANAGEMENT_LIST,
  payload: data
});

const resetTimelineEventManagementList = () => ({
  type: RESET_TIMELINE_EVENT_MANAGEMENT_LIST
});

const updateTimelineEventManagementDetails = (data: Partial<TTimelineEventManagementDetailsState>) => ({
  type: UPDATE_TIMELINE_EVENT_MANAGEMENT_DETAILS,
  payload: data
});

const resetTimelineEventManagementDetails = () => ({
  type: RESET_TIMELINE_EVENT_MANAGEMENT_DETAILS
});

const createTimelineEvent = (params: TCreateTimelineEvent) => ({
  type: CREATE_TIMELINE_EVENT,
  payload: params
});

const updateTimelineEvent = (id: number, params: TUpdateTimelineEvent) => ({
  type: UPDATE_TIMELINE_EVENT,
  payload: { id, params }
});

const deleteTimelineEvent = (id: number) => ({
  type: DELETE_TIMELINE_EVENT,
  payload: id
});

const setRequestPending = (pending: boolean) => ({
  type: SET_REQUEST_PENDING,
  payload: pending
});

export const actions = {
  fetchTimelineEventManagementList,
  fetchTimelineEventManagementDetails,
  updateTimelineEventManagementList,
  updateTimelineEventManagementDetails,
  createTimelineEvent,
  updateTimelineEvent,
  deleteTimelineEvent,
  resetTimelineEventManagementList,
  resetTimelineEventManagementDetails,
  setRequestPending
};

export const actionTypes = {
  FETCH_TIMELINE_EVENT_MANAGEMENT_LIST,
  FETCH_TIMELINE_EVENT_MANAGEMENT_DETAILS,
  CREATE_TIMELINE_EVENT,
  UPDATE_TIMELINE_EVENT,
  DELETE_TIMELINE_EVENT,
  SET_REQUEST_PENDING,
  RESET_TIMELINE_EVENT_MANAGEMENT_LIST,
  RESET_TIMELINE_EVENT_MANAGEMENT_DETAILS
};

export function reducer(state = getInitialState(), action: TAction<any>) {
  switch (action.type) {
    case RESET_TIMELINE_EVENT_MANAGEMENT_LIST:
      return {
        ...state,
        list: getInitialState().list
      };
    case RESET_TIMELINE_EVENT_MANAGEMENT_DETAILS:
      return {
        ...state,
        details: getInitialState().details
      };
    case UPDATE_TIMELINE_EVENT_MANAGEMENT_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          ...action.payload
        }
      };
    case UPDATE_TIMELINE_EVENT_MANAGEMENT_DETAILS:
      return {
        ...state,
        details: {
          ...state.details,
          ...action.payload
        }
      };
    default:
      return state;
  }
}
